import type { SanityArticleCard } from "@ouster/shared";
import React from "react";
import { hasItems } from "~/features/app/utils";
import { BlogArticleCard } from "~/features/blog/article-card";
import { AdaptiveSection } from "~/features/ui/adaptive-section";
type Props = {
  headline?: string | null;
  articles?: SanityArticleCard[] | null;
};
export function BlogHighlightedArticles(props: Props) {
  const {
    headline,
    articles
  } = props;
  if (!hasItems(articles)) {
    return null;
  }
  return <AdaptiveSection headline={headline ?? undefined} mode="light" theme="grey">
      {articles.map((article, idx) => <BlogArticleCard article={article} key={article._id ?? idx} featured={articles.length === 1} />)}
    </AdaptiveSection>;
}